export const normalizeListResponse = (payload) => {
  if (Array.isArray(payload)) {
    return {
      results: payload,
      count: payload.length,
      next: null,
      previous: null
    };
  }

  const data = payload || {};
  const results = Array.isArray(data.results) ? data.results : [];
  const count = typeof data.count === 'number' ? data.count : results.length;

  return {
    results,
    count,
    next: data.next || null,
    previous: data.previous || null
  };
};

export const buildPaginationMeta = ({
  response,
  page,
  pageSize
}) => {
  const totalCount = response.count;
  const safePageSize = pageSize || (response.results.length > 0 ? response.results.length : 0);
  const safePage = page ?? 1;
  const totalPages = safePageSize > 0 ? Math.ceil(totalCount / safePageSize) : 1;

  return {
    count: totalCount,
    page: safePage,
    pageSize: safePageSize,
    totalPages,
    hasNext: Boolean(response.next),
    hasPrevious: Boolean(response.previous)
  };
};
